export default __webpack_public_path__ + "static/media/circle-check-green.e7f6556a.svg";